import { fork } from 'redux-saga/effects';
import socketsSaga from './sockets/sagas';
import usersSaga from './users/sagas';
import interactiveSaga from './interactive/sagas';
import finalTestSaga from './finalTest/sagas';
import callToActionSaga from './callToAction/sagas';
import privateChatSaga from './privateChat/sagas';
import ticketSaga from './ticket/sagas';
import certeficateSaga from './certeficate/sagas';
import technicalTextsSaga from './technicalTexts/sagas';

export default function* rootSaga() {
  yield fork(socketsSaga);
  yield fork(usersSaga);
  yield fork(interactiveSaga);
  yield fork(finalTestSaga);
  yield fork(callToActionSaga);
  yield fork(privateChatSaga);
  yield fork(ticketSaga);
  yield fork(certeficateSaga);
  yield fork(technicalTextsSaga);
}
